import { z } from 'zod';
export const roleRequirementSchema = z.object({
    role: z.string().min(1),
    mandatory: z.array(z.string()).default([]),
    beneficial: z.array(z.string()).default([]),
    other: z.array(z.string()).default([]),
    displayOrder: z.number().int().optional(),
});
export const reorderRoleRequirementsSchema = z.object({
    order: z.array(z.string()).min(1),
});
//# sourceMappingURL=role-requirement.js.map